import { GET_JOB_PROFILE_REQUEST,
    GET_JOB_PROFILE_SUCCESS,
    GET_JOB_PROFILE_FAILURE } from '../../actions/profile/constants';

const INITIAL_STATE = {
    fetching: false,
    error: false,
    errorMsg: null,
    all: []
}

export default function jobProfile(state = INITIAL_STATE, action)  {
    switch (action.type) {
        case GET_JOB_PROFILE_REQUEST:
            return {
                ...state,
                fetching: true,
            }
        case GET_JOB_PROFILE_SUCCESS:
            return {
                ...state,
                all: action.payload,
                fetching: false
            }
        case GET_JOB_PROFILE_FAILURE:
            return {
                ...state,
                fetching: false,
                error: true,
                errorMsg: action.error
            }
        default:
            return state;
    }
}